export class CustomResponse<T> {
  constructor(
    public readonly Success: boolean,
    public readonly Data: T,
    public readonly Notifications: any
  ) { }

}
